import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';

@Component({
    selector: 'app-complemento-web',
    template: `<router-outlet></router-outlet>`,
    styles: [],
    imports: [RouterOutlet]
})
export class ComplementoWebComponent {

}
